import { put, select } from 'redux-saga/effects'
import { selectGameAPIData } from '../selectors'
import * as actions from '../actions'
import { randomizeArray } from '../../../utils/util';


export function* getRhymingIdentificationData(payload, getGameData) {
    const { from } = payload;

    let rhymingState = yield select(selectGameAPIData)

    if (!rhymingState) {
        rhymingState = yield* getGameData(
            null,
            null,
            null,
            'RHYMING_IDENTIFICATION',
            from,
            null,
            null
        )
        yield put(actions.setGameData({ apiData: rhymingState }))
    }


    let resultItems = [];

    rhymingState.map((item, idx) => {
        let answerData = [];

        for (let i = 1; i < 4; i++) {
            answerData.push(
                { id: item.id + i, isVisible: true, answerImage: item[`word${i}_image`], answerAudio: item[`word${i}_sound`], word: item[`word${i}`] },
            )

        }

        return (
            resultItems.push({
                id: item.id,
                audioPath: item.audio_path,
                imagePath: item.image_path,
                correct: item.rhyme,
                answers: randomizeArray(answerData)
            })
        )
    })



    const displayData = randomizeArray(resultItems)
    const metaFieldData = {
        activeItemIndex: 0,
        gameData: displayData,
        droppedAnswer: [],
        invisibleAnswerIds: [],
        questionsAnswered: [],
        activeAnswers: displayData[0].answers,
        correctAnswerCount: 0,
    }
    return { displayData, metaFieldData }
}